
import {
  defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import { Modal } from 'ant-design-vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import ColunaGrade from '@/core/components/Tela/ColunaGrade.vue';
import Icone from '@/core/components/Icone.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import Paginacao from '@/core/components/Tela/Paginacao.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import BuscaGeral from '@/core/components/BuscaAvancada/BuscaGeral.vue';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { EVinculoEmpresa } from '@/core/models/Enumeradores/EEVinculoEmpresa';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import storeSistema from '@/store/storeSistema';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { useGradeBase } from '@/core/composables/GradeBase';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import Card from '@/core/components/Tela/Card.vue';
import { ETipoTituloFinanceiro } from '@/models/Enumeradores/Financeiro/ETipoTituloFinanceiro';
import { EStatusTituloFinanceiro } from '@/models/Enumeradores/Financeiro/EStatusTituloFinanceiro';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import { IDTOUsuarioPermissoes } from '@/models/DTO/MeuSistema/Usuarios/IDTOUsuarioPermissoes';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import ServicoParametros from '@/servicos/MeuSistema/ServicoParametros';
import OrdemProducaoModal from './OrdemProducaoModal.vue';
import { IDTOOrdemProducao } from '@/models/DTO/PCP/IDTOOrdemProducao';
import { IBuscaAvancada } from '@/core/models/BuscaAvancada/IBuscaAvancada';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import ServicoOrdemProducao from '@/servicos/PCP/ServicoOrdemProducao';
import { IFiltroGenericoAdicionado } from '@/core/models/BuscaAvancada/IFiltroGenericoAdicionado';
import { IFiltroGenerico } from '@/core/models/BuscaAvancada/IFiltroGenerico';
import { EOperadorLogico } from '@/core/models/Enumeradores/EOperadorLogico';
import { ETipoDado } from '@/core/models/Enumeradores/ETipoDado';
import { ECondicao } from '@/core/models/Enumeradores/ECondicao';
import { EStatusProducao } from '@/models/Enumeradores/PCP/EStatusProducao';

export default defineComponent({
  name: 'ContaPagar',
  components: {
    ColunaGrade,
    Icone,
    Card,
    MensagemSemDados,
    BuscaGeral,
    TituloPadrao,
    PreviewPdf,
    OrdemProducaoModal,
    Paginacao,
  },
  setup(props) {
    const servicoOrdemProducao = new ServicoOrdemProducao();
    const servicoSistema = new ServicoSistema();
    const servicoParametro = new ServicoParametros();
    servicoParametro.requisicaoSistema();
    const {
      telaBase, obterPermissoes, preencherEmpresasDisponiveis, verificaConceitoParaApresentarEmpresas,
      defineEmpresasSelecionadasComPermissao, filtrarPermissaoDadosUsuarioMultiEmpresas,
      apresentarMensagemSucesso, apresentarMensagemAlerta, apresentarMensagemErro,
      adicionarAtalho, removerAtalho, preencherDadosRota, salvarPreferenciasFiltros, salvarPreferenciasOrdenacao,
      carregarPreferenciasFiltros, carregarPreferenciasOrdenacao, carregarPreferenciasGrade, salvarPreferenciasGrade,
    } = useTelaBase();

    const { gradeBase, redefinirPersonalizacaoColunas } = useGradeBase();

    const state = reactive({
      empresaSelecionada: 0,
      exibirPersonalizarColunas: false,
      exibirModal: false,
      operacaoLancamento: {} as ITelaOperacao,
      autorizacoes: [] as IDTOUsuarioPermissoes[],
      atualizarGrid: false,
      arquivosPdf: [] as IArquivoPdf[],
      ordemProducao: [] as IDTOOrdemProducao[],
      buscaAvancada: {} as IBuscaAvancada,
      buscaRapida: '',
    });
    telaBase.apresentarEmpresas = false;

    function preencherColunas() {
      gradeBase.colunasMobile = [
        {
          title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false,
        },
        {
          title: 'Produto', dataIndex: 'produto', key: 'Descricao', position: 2, visible: true,
        },
      ];

      gradeBase.colunasPadrao = [
        {
          title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false,
        },
        {
          title: 'Número', dataIndex: 'numeroInterno', key: 'NumeroInterno', position: 2, visible: true, width: 50, ellipsis: true, customRenderRow: ECustomRenderRow.LinkAcao, align: 'left', ordering: true, filtering: true,
        },
        {
          title: 'Produto', dataIndex: 'descricao', key: 'Descricao', position: 2, visible: true, width: 100, ellipsis: true, customRenderRow: ECustomRenderRow.LinkAcao, align: 'left', ordering: true, filtering: true,
        },
        {
          title: 'Tipo de Produção', dataIndex: 'tipoProducao', key: 'TipoProducao', position: 3, visible: true, ellipsis: true, customRenderRow: ECustomRenderRow.LinkAcao, width: 50, ordering: true, filtering: true,
        },
        {
          title: 'Status', dataIndex: 'descricaoStatus', key: 'Status', position: 4, visible: true, ellipsis: true, width: 50, ordering: true,
        },
        {
          title: 'Quantidade', dataIndex: 'quantidade', key: 'Quantidade', position: 5, visible: true, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right', width: 50, ordering: true,
        },
        {
          title: 'Numero do Lote', dataIndex: 'numeroLote', key: 'NumeroLote', position: 5, visible: true, align: 'left', width: 50, ordering: true, filtering: true,
        },
        {
          title: 'Qtd. Produzida', dataIndex: 'qtdProduzidaFinal', key: 'QuantidadeProduziada', position: 5, visible: true, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right', width: 50, ordering: true,
        },
        {
          title: 'Data de Criação', dataIndex: 'dataCriacao', key: 'DataCriacao', position: 6, visible: true, customRenderRow: ECustomRenderRow.MascararData, ordering: true, width: 70, align: 'center',
        },
        {
          title: 'Data de Inicio', dataIndex: 'dataInicio', key: 'DataInicio', position: 7, visible: true, customRenderRow: ECustomRenderRow.MascararData, ordering: true, width: 70, align: 'center',
        },
        {
          title: 'Data de Conclusão', dataIndex: 'dataConclusao', key: 'DataConclusao', position: 8, visible: true, customRenderRow: ECustomRenderRow.MascararData, ordering: true, width: 70, align: 'center',
        },
        {
          title: 'Ações', key: 'acoes', position: 9, visible: true, width: 75, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
        },
      ];
    }

    function adicionarFiltrosIniciais() {
      const filtroGenerio1 = {} as IFiltroGenericoAdicionado;
      state.buscaAvancada.chaveFiltrosAdicionados += 1;
      filtroGenerio1.codigo = state.buscaAvancada.chaveFiltrosAdicionados;
      filtroGenerio1.filtro = {} as IFiltroGenerico;
      filtroGenerio1.filtro.identificador = 'StatusOrdemProducao';
      filtroGenerio1.apresentacao = 'Status';
      filtroGenerio1.filtro.tipoDado = 1;
      filtroGenerio1.filtro.operador = EOperadorLogico.E;
      filtroGenerio1.filtro.apresentacao = 'Status';
      filtroGenerio1.filtro.condicao = 4;
      filtroGenerio1.filtro.valores = [`${EStatusProducao.Pendente}`];
      filtroGenerio1.detalhes = 'Igual: Pendente';
      state.buscaAvancada.filtrosAdicionados.push(filtroGenerio1);

      const filtroGenerio2 = {} as IFiltroGenericoAdicionado;
      state.buscaAvancada.chaveFiltrosAdicionados += 1;
      filtroGenerio2.codigo = state.buscaAvancada.chaveFiltrosAdicionados;
      filtroGenerio2.filtro = {} as IFiltroGenerico;
      filtroGenerio2.filtro.identificador = 'StatusOrdemProducao';
      filtroGenerio2.apresentacao = 'Status';
      filtroGenerio2.filtro.tipoDado = 1;
      filtroGenerio2.filtro.operador = EOperadorLogico.OU;
      filtroGenerio2.filtro.apresentacao = 'Status';
      filtroGenerio2.filtro.condicao = 4;
      filtroGenerio2.filtro.valores = [`${EStatusProducao.Produzindo}`];
      filtroGenerio2.detalhes = 'Igual: Produzindo';
      state.buscaAvancada.filtrosAdicionados.push(filtroGenerio2);
    }

    function normalizarTexto(valor: string): string {
      return (valor || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\./g, '')
        .replace(/\s+/g, '')
        .toLowerCase();
    }

    function obterIdentificadorConsulta(chaveColuna: string): string {
      if (!UtilitarioGeral.validaLista(telaBase.propriedadesConsulta)) {
        return chaveColuna;
      }

      const propriedadePorIdentificador = telaBase.propriedadesConsulta
        .find((item) => item.identificador === chaveColuna && (item.filtro || item.ordenacao));
      if (propriedadePorIdentificador !== undefined) {
        return propriedadePorIdentificador.identificador;
      }

      const coluna = gradeBase.colunasPadrao.find((item) => item.key === chaveColuna);
      if (coluna === undefined) {
        return chaveColuna;
      }

      const tituloNormalizado = normalizarTexto(String(coluna.title));
      const propriedadePorApresentacao = telaBase.propriedadesConsulta
        .find((item) => normalizarTexto(item.apresentacao) === tituloNormalizado && (item.filtro || item.ordenacao));
      if (propriedadePorApresentacao !== undefined) {
        return propriedadePorApresentacao.identificador;
      }

      return chaveColuna;
    }

    function preencherOrdenacaoConsulta(parametrosConsulta: IParametrosConsulta) {
      telaBase.ordenacaoSelecionada.forEach((ordenacao) => {
        const identificador = obterIdentificadorConsulta(ordenacao.identificador);
        parametrosConsulta.ordenacao.push(`${identificador}|${ordenacao.ordem}`);
      });
    }

    function adicionarFiltrosCabecalhoAplicados() {
      Object.entries(gradeBase.filtrosCabecalho).forEach(([identificador, valor]) => {
        const termo = (valor ?? '').trim();
        if (termo !== '') {
          const identificadorMapeado = obterIdentificadorConsulta(identificador);
          gradeBase.filtrosAplicados.push({
            identificador: identificadorMapeado,
            apresentacao: `${identificadorMapeado}: contém ${termo}`,
            tipoDado: ETipoDado.Texto,
            condicao: ECondicao.Contem,
            valores: [termo],
            operador: EOperadorLogico.E,
          } as IFiltroGenerico);
        }
      });
    }

    async function buscarOrdemProducao() {
      state.ordemProducao = [];
      gradeBase.codigosSelecionados = [];
      gradeBase.filtrosAplicados = [];

      if (UtilitarioGeral.validaLista(state.buscaAvancada.filtrosAdicionados)) {
        state.buscaAvancada.filtrosAdicionados.forEach((item) => {
          gradeBase.filtrosAplicados.push(item.filtro);
        });
      }
      adicionarFiltrosCabecalhoAplicados();

      const parametrosConsulta = {} as IParametrosConsulta;
      parametrosConsulta.empresas = [state.empresaSelecionada];
      parametrosConsulta.numeroPagina = gradeBase.paginacao.current;
      parametrosConsulta.qtdeRegistrosPagina = gradeBase.paginacao.pageSize;
      parametrosConsulta.qtdeRegistrosTotal = gradeBase.paginacao.total;
      parametrosConsulta.ordenacao = Array<string>();
      parametrosConsulta.valorBuscaRapida = state.buscaRapida;

      preencherOrdenacaoConsulta(parametrosConsulta);

      if (!UtilitarioGeral.validaLista(telaBase.ordenacaoSelecionada)) {
        parametrosConsulta.ordenacao.push('CodigoOrdemProducao|ASC');
      }

      telaBase.carregando = true;
      const listaPaginada = await servicoOrdemProducao.buscaAvancada(parametrosConsulta, gradeBase.filtrosAplicados);
      state.ordemProducao = listaPaginada.dados;
      gradeBase.paginacaoApi = listaPaginada.metaData;
      telaBase.carregando = false;
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.empresaSelecionada);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      state.autorizacoes = await servicoSistema.obterVariasPermissoesAutorizacoesUsuario(['AUT_BAIXAS_CONTAS_PAGAR']);
      await buscarOrdemProducao();
    }

    async function aplicarFiltros() {
      gradeBase.paginacao.current = 1;
      await buscarOrdemProducao();
    }

    function incluir() {
      state.operacaoLancamento = {} as ITelaOperacao;
      state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Incluir;
      state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
      state.operacaoLancamento.codigoRegistro = 0;
      state.operacaoLancamento.empresaSelecionada = state.empresaSelecionada;
      state.exibirModal = true;
    }

    function editar(codigoRegistro: number) {
      state.operacaoLancamento = {} as ITelaOperacao;
      state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Alterar;
      state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
      state.operacaoLancamento.codigoRegistro = codigoRegistro;
      state.operacaoLancamento.empresaSelecionada = state.empresaSelecionada;
      state.exibirModal = true;
    }

    async function imprimir(tipoArquivoRelatorio:ETipoArquivo, codigoRegistro?:number) {
      gradeBase.filtrosAplicados = [];

      if (UtilitarioGeral.validaLista(state.buscaAvancada.filtrosAdicionados)) {
        state.buscaAvancada.filtrosAdicionados.forEach((item) => {
          gradeBase.filtrosAplicados.push(item.filtro);
        });
      }
      adicionarFiltrosCabecalhoAplicados();

      const parametrosConsulta = {} as IParametrosConsulta;
      parametrosConsulta.empresas = [state.empresaSelecionada];
      parametrosConsulta.numeroPagina = 1;
      parametrosConsulta.qtdeRegistrosPagina = 0;
      parametrosConsulta.qtdeRegistrosTotal = 0;
      parametrosConsulta.ordenacao = Array<string>();

      preencherOrdenacaoConsulta(parametrosConsulta);

      if (!UtilitarioGeral.validaLista(telaBase.ordenacaoSelecionada)) {
        parametrosConsulta.ordenacao.push('CodigoOrdemProducao|ASC');
      }
      let codigosSelecionados: number[] = [];
      if (codigoRegistro !== undefined && codigoRegistro > 0) {
        codigosSelecionados.push(codigoRegistro);
      } else {
        codigosSelecionados = gradeBase.codigosSelecionados;
      }

      telaBase.carregando = true;
      const retornoRelatorio = await servicoOrdemProducao.relatorioPadrao(tipoArquivoRelatorio, parametrosConsulta, gradeBase.filtrosAplicados, codigosSelecionados);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function carregarPreferencias() {
      telaBase.preferencias = await new ServicoSistema().obterPreferenciaRecurso(telaBase.identificadorRecurso, telaBase.empresasSelecionadas);
      if (telaBase.preferencias !== null) {
        state.buscaAvancada.filtrosAdicionados = carregarPreferenciasFiltros(telaBase.preferencias);
        telaBase.ordenacaoSelecionada = carregarPreferenciasOrdenacao(telaBase.preferencias);
        gradeBase.colunas = carregarPreferenciasGrade(gradeBase.colunasPadrao, telaBase.preferencias);
      }
    }

    function obterStatus(status: EStatusProducao) {
      switch (status) {
        case EStatusProducao.Pendente:
          return 'pendente';
        case EStatusProducao.Produzindo:
          return 'produzindo';
        case EStatusProducao.Concluido:
          return 'concluido';
        case EStatusProducao.Cancelado:
          return 'cancelado';
        default:
          return 'interrompido';
      }
    }

    onBeforeMount(async () => {
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      gradeBase.layoutMobile = storeSistema.state.layoutMobile;
      state.ordemProducao = [];
      preencherDadosRota();
      await obterPermissoes(ETipoPermissao.Dados);
      await preencherEmpresasDisponiveis();
      await defineEmpresasSelecionadasComPermissao();
      verificaConceitoParaApresentarEmpresas();
      telaBase.propriedadesConsulta = await servicoOrdemProducao.obterPropriedadesConsulta();
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas([state.empresaSelecionada]);
      if (telaBase.propriedadesConsulta.length > 0) {
        state.buscaAvancada.filtros = telaBase.propriedadesConsulta.filter((item) => item.filtro === true);
        state.buscaAvancada.ordenacao = telaBase.propriedadesConsulta.filter((item) => item.ordenacao === true);
      }
      state.buscaAvancada.filtrosAdicionados = [];
      state.buscaAvancada.chaveFiltrosAdicionados = 0;
      preencherColunas();
      gradeBase.colunas = gradeBase.colunasPadrao;
      gradeBase.paginacao.current = 1;
      gradeBase.paginacao.pageSize = 30;
      gradeBase.paginacao.pageSizeOptions = ['10', '20', '50', '100', '500'];

      await carregarPreferencias();
      if (!UtilitarioGeral.validaLista(state.buscaAvancada.filtrosAdicionados)) {
        adicionarFiltrosIniciais();
      }

      await buscarOrdemProducao();
    });

    async function atualizarInformacoesTela() {
      state.atualizarGrid = true;
    }

    async function excluir(codigo: number) {
      const retorno = await servicoOrdemProducao.excluir(codigo);
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        await atualizarInformacoesTela();
      } else if (retorno.status === EStatusRetornoRequisicao.Alerta) {
        Modal.warning({
          title: 'Não foi possível concluir a exclusão!',
          content: retorno.mensagem,
        });
      }
    }

    async function confirmarExclusao(objeto: IDTOOrdemProducao) {
      Modal.confirm({
        title: 'Você confirma a exclusão da Ordem de Produção ',
        content: `${objeto.numeroInterno} ?`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        centered: true,
        onOk: async () => { await excluir(objeto.codigo); },
      });
    }

    function verificarAutorizacao(identificadorAutorizacao: string) {
      return servicoSistema.verificaAutorizacao(state.empresaSelecionada, identificadorAutorizacao, state.autorizacoes);
    }

    function textoCodigosSelecionados():string {
      if (gradeBase.codigosSelecionados.length === 1) { return '1 - Registro selecionado'; }

      if (gradeBase.codigosSelecionados.length > 1) { return `${gradeBase.codigosSelecionados.length} - Registros selecionados`; }

      return '';
    }
    watch(() => storeSistema.state.layoutMobile, () => {
      gradeBase.layoutMobile = storeSistema.state.layoutMobile;
      preencherColunas();
    });

    watch(() => state.exibirModal, (newValue) => {
      if (!newValue && state.atualizarGrid) {
        buscarOrdemProducao();
        state.atualizarGrid = false;
      }
    });

    function apresentarPersonalizarColuna() {
      state.exibirPersonalizarColunas = !state.exibirPersonalizarColunas;
    }
    return {
      state,
      props,
      window,
      ETipoTituloFinanceiro,
      EStatusTituloFinanceiro,
      EVinculoEmpresa,
      ETipoArquivo,
      ECustomRenderRow,
      UtilitarioMascara,
      UtilitarioData,
      UtilitarioGeral,
      storeSistema,
      telaBase,
      gradeBase,
      incluir,
      editar,
      confirmarExclusao,
      aplicarFiltros,
      buscarOrdemProducao,
      imprimir,
      atualizarSelecaoEmpresas,
      adicionarAtalho,
      removerAtalho,
      atualizarInformacoesTela,
      verificarAutorizacao,
      textoCodigosSelecionados,
      salvarPreferenciasFiltros,
      salvarPreferenciasOrdenacao,
      salvarPreferenciasGrade,
      redefinirPersonalizacaoColunas,
      apresentarPersonalizarColuna,
      obterStatus,
    };
  },
});
